import script from "./SearchRequirement.vue?vue&type=script&setup=true&lang=ts"
export * from "./SearchRequirement.vue?vue&type=script&setup=true&lang=ts"

import "./SearchRequirement.vue?vue&type=style&index=0&id=609a0e18&lang=scss&scoped=true"

import exportComponent from "/Users/BlackPaw/Developer/acebed_vue3_web/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-609a0e18"]])

export default __exports__